import { useSyncExternalStore } from 'react';

export type Browser = 'safari-ios' | 'chrome-ios' | 'chrome-android' | 'samsung-android' | 'unknown';

function detectBrowser(): Browser {
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua);
  const isAndroid = /Android/.test(ua);
  if (isIOS && /CriOS/.test(ua)) return 'chrome-ios';
  if (isIOS) return 'safari-ios';
  if (isAndroid && /SamsungBrowser/.test(ua)) return 'samsung-android';
  if (isAndroid && /Chrome/.test(ua)) return 'chrome-android';
  return 'unknown';
}

const emptySubscribe = () => () => {};

export function useDetectedBrowser(): Browser {
  // Detect on the client only; the server (and first hydration render) sees 'unknown'.
  return useSyncExternalStore(emptySubscribe, detectBrowser, () => 'unknown');
}

/** A phone or tablet browser. iPadOS reports a Mac user agent, so touch points are what give it away. */
function detectMobileBrowser(): boolean {
  const ua = navigator.userAgent;
  return /Android|iPhone|iPad|iPod/.test(ua) || (ua.includes('Mac') && navigator.maxTouchPoints > 1);
}

/** Whether this is a phone or tablet browser. False on the server and the first hydration render. */
export function useIsMobileBrowser(): boolean {
  return useSyncExternalStore(emptySubscribe, detectMobileBrowser, () => false);
}
